import { configureStore } from '@reduxjs/toolkit'
import { getDefaultMiddleware } from '@reduxjs/toolkit'
import appReducer from './appSlice'
import userReducer from './userSlice'
import generalSlice from './generalSlice'

const customizedMiddleware = getDefaultMiddleware({
    serializableCheck: false,
})

export const store = configureStore({
    reducer: {
        appSlice: appReducer,
        userSlice: userReducer,
        generalSlice: generalSlice,
    },
    middleware: customizedMiddleware,
})
